"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
import { MessageCircle, FileText } from "lucide-react";
export default function CallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="231130" id="cta-final" className="bg-background text-foreground relative overflow-hidden">
      {}
      <div className="w-full h-px bg-border/30" />

      {}
      <div className="absolute inset-0 pointer-events-none bg-muted/30" />

      <div ref={ref} className={`relative z-10 flex flex-col items-center justify-center text-center px-6 py-20 md:py-32 max-w-4xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        {}
        <h2 className="font-default font-bold text-4xl md:text-5xl lg:text-6xl leading-tight tracking-tighter mb-6 text-foreground">
          Pronto para começar?
        </h2>

        {}
        <p className="font-default text-base md:text-lg max-w-2xl mb-10 leading-relaxed text-muted-foreground">
          Fale com a equipe da ITC+ e descubra como podemos ajudar sua empresa a crescer.
        </p>

        {}
        <div className="flex flex-col sm:flex-row gap-4 items-center justify-center">
          {}
          <Button asChild className="font-default font-semibold text-sm px-10 py-3 h-14 rounded-full transition-all duration-300 hover:opacity-90 hover:scale-105 bg-primary text-primary-foreground shadow-xl">
            <Link to="https://wa.me/5511969100007?text=Olá,%20vim%20pelo%20site%20da%20ITC+%20e%20quero%20entender%20como%20voc%C3%AAs%20podem%20me%20ajudar">
              <MessageCircle className="size-5" />
              Falar no WhatsApp
            </Link>
          </Button>

          {}
          <Button asChild variant="ghost" className="font-default font-semibold text-sm px-10 py-3 h-14 rounded-full transition-all duration-300 hover:scale-105 border-2 border-primary text-primary bg-transparent">
            <Link to="https://itcmais.com/o-estudio/">
              <FileText className="size-5" />
              Ver o estúdio
            </Link>
          </Button>
        </div>
      </div>

      {}
      <div className="w-full h-px bg-border/30" />
    </section>;
}